import getters from './getters';
import mutations from './mutations';

const state = {
  countries: [],
  countriesMap: '',
  countriesAsOf: '',
  regions: [],
  regionsMap: '',
  regionsAsOf: ''
};

export default {
  state,
  getters,
  mutations
};
